export class CategorieProduit {
    type: any;
    code_categorie: any;
    nom: string = "";
    description: string = "";


    private errorMessage: string;

    constructor() {
        this.errorMessage = "";
    }

    // Récupérer le message d'erreur
    getErrorMessage(): string {
        return this.errorMessage;
    }

    // Vérifier si on peut sauvegarder
    canSave(): boolean {
        // Vérification du nom

         if (!this.type || this.type.trim() === "") {
            this.errorMessage = "Veuillez saisir le type de la categorie";
            return false;
        }
         if (!this.code_categorie || this.code_categorie.trim() === "") {
            this.errorMessage = "Veuillez saisir le code de la categorie";
            return false;
        }
        if (!this.nom || this.nom.trim() === "") {
            this.errorMessage = "Veuillez saisir le nom de la categorie";
            return false;
        }
         if (!this.description || this.description.trim() === "") {
            this.errorMessage = "Veuillez saisir la description";
            return false;
        }

        // Si tous les champs sont valides
        this.errorMessage = ""; // Réinitialiser le message d'erreur
        return true;
    }
}
